import { Typography } from '@mui/material';
import type { GridColDef } from '@mui/x-data-grid';
import type { AnimalCompraRow } from './AnimalCompraRow';

export const colDefinitions: GridColDef<AnimalCompraRow>[] = [
  {
    field: 'areteSiiniga',
    headerName: 'SIINIGA',
    headerAlign: 'center',
    width: 130,
    editable: false,
    valueFormatter: (value) => {
      const valueStr = String(value ?? '');
      return valueStr.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3');
    }
  },
  {
    field: 'historialSiiniga',
    type: 'actions',
    headerName: '',
    width: 60,
    cellClassName: 'actions'
  },
  {
    field: 'areteTemporal',
    headerName: 'Temporal',
    headerAlign: 'center',
    width: 130,
    editable: false,
    valueFormatter: (value) => {
      const valueStr = String(value ?? '');
      return valueStr.replace(/([a-zA-Z]{1})([0-9]{1,3})/, '$1-$2');
    }
  },
  {
    field: 'historialTemporal',
    type: 'actions',
    headerName: '',
    width: 60,
    cellClassName: 'actions'
  },
  {
    field: 'tipoGanado',
    headerName: 'Tipo',
    headerAlign: 'center',
    width: 180,
    editable: false
  },
  {
    field: 'kgCompra',
    align: 'right',
    headerName: 'Kg. Compra',
    headerAlign: 'center',
    width: 115,
    type: 'number',
    editable: false
  },
  {
    field: 'kgLlegada',
    align: 'right',
    headerName: 'Kg. Llegada',
    headerAlign: 'center',
    width: 115,
    type: 'number',
    editable: false
  },
  {
    field: 'diferencialKg',
    align: 'right',
    headerName: 'Diferencial Kg.',
    headerAlign: 'center',
    width: 120,
    type: 'number',
    editable: false,
    valueGetter: (_, row) => {
      return row.kgCompra - row.kgLlegada;
    }
  },
  {
    field: 'diferencialPorcentual',
    align: 'right',
    headerName: 'Diferencial %',
    headerAlign: 'center',
    width: 115,
    type: 'number',
    editable: false,
    valueGetter: (_, row) => {
      return 100 - (row.kgLlegada * 100) / row.kgCompra;
    }
  },
  {
    field: 'kgNetos',
    align: 'right',
    headerName: 'Kg. Netos',
    headerAlign: 'center',
    width: 130,
    type: 'number',
    editable: false,
    valueGetter: (_, row) => {
      return row.kgCompra > 300 && !row.omiteDescuento ? row.kgCompra - (row.kgCompra * 0.05) : row.kgCompra;
    }
  },
  {
    field: 'omiteDescuento',
    // headerName: 'Omite Descuento',
    renderHeader: () => (
      <Typography fontWeight="bold" textAlign="center">
        Omite
        <br />
        Descuento
      </Typography>
    ),
    headerAlign: 'center',
    width: 100,
    type: 'boolean',
    editable: true
  },
  {
    field: 'precio',
    headerName: 'Precio',
    headerAlign: 'center',
    width: 100,
    type: 'number',
    editable: true,
    align: 'right',
    valueSetter: (value, row) => {
      const kgNetos =
        row.kgCompra > 300 && !row.omiteDescuento ? row.kgCompra / 1.05 : row.kgCompra;
      const importe = kgNetos * value;

      return { ...row, precio: value, importe, kgNetos } as AnimalCompraRow;
    },
    valueFormatter: (value: number | null) => {
      return value != null
        ? value.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })
        : '';
    }
  },
  {
    field: 'importe',
    align: 'right',
    headerName: 'Importe',
    headerAlign: 'center',
    width: 100,
    type: 'number',
    editable: false,
    valueFormatter: (value: number | null) => {
      return value != null
        ? value.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })
        : '';
    }
  },
  {
    field: 'tienePapeles',
    headerName: 'Papeles',
    headerAlign: 'center',
    width: 100,
    type: 'boolean',
    editable: false
  },
  {
    field: 'reemo',
    headerName: 'REEMO',
    headerAlign: 'center',
    width: 130,
    editable: false
  },
  {
    field: 'actions',
    type: 'actions',
    headerName: 'Acciones',
    headerAlign: 'center',
    width: 100,
    cellClassName: 'actions'
  }
];
